export const PAGINATION_RESULTS_PER_PAGE_SIZES = [12, 24, 32, 48];
export const PAGINATION_RESULTS_PER_PAGE_DEFAULT_SIZE = 12;
